export default {"src":"/_next/static/media/default_2.d63eb34e.svg","height":144,"width":145,"blurWidth":0,"blurHeight":0};